import React, { useEffect, useState } from 'react';
import RoutesMain from "./routes";
import { Snackbar, Button, Alert } from '@mui/material';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';

// Trigger build 2026-03-04 09:37
function App() {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    const handleSWUpdate = (event: Event) => {
      const customEvent = event as CustomEvent;
      const registration = customEvent.detail as ServiceWorkerRegistration;
      if (registration.waiting) {
        setWaitingWorker(registration.waiting);
        setShowReload(true);
      }
    };

    window.addEventListener('pwaUpdate', handleSWUpdate);
    return () => window.removeEventListener('pwaUpdate', handleSWUpdate);
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
    window.location.reload();
  };

  return (
    <>
      <RoutesMain />
      <Snackbar
        open={showReload}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="info"
          action={
            <Button color="inherit" size="small" onClick={reloadPage}>
              UPDATE
            </Button>
          }
        >
          A new version of ARPT TOKEN TOOLS is available!
        </Alert>
      </Snackbar>
      <FloatingWhatsAppButton />
    </>
  );
}

export default App;